import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
const ProtectedRoute: React.FC = () => {
  const {
    user,
    isLoading
  } = useAuth();
  if (isLoading) {
    // Show a loading spinner or placeholder while checking authentication
    return <div className="flex items-center justify-center h-screen" data-id="element-173">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600" data-id="element-174"></div>
      </div>;
  }
  // If user is not authenticated, redirect to login
  if (!user) {
    return <Navigate to="/login" replace data-id="element-175" />;
  }
  // If user is authenticated, render the child routes
  return <Outlet data-id="element-176" />;
};
export default ProtectedRoute;